const load = (src) => new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });

const cover = (ctx, im, x, y, w, h, r) => {
  const s = Math.max(w / im.width, h / im.height), sw = w / s, sh = h / s;
  ctx.save(); ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.clip();
  ctx.drawImage(im, (im.width - sw) / 2, Math.max(0, (im.height - sh) * 0.2), sw, sh, x, y, w, h); ctx.restore();
};

export const makeStoryCard = async ({ image, name, look, price }) => {
  const W = 1080, H = 1920, c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");
  const g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, "#FBF1EC"); g.addColorStop(1, "#F1DCD4");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
  const rg = ctx.createRadialGradient(W * 0.8, H * 0.2, 0, W * 0.8, H * 0.2, 600); rg.addColorStop(0, "rgba(232,180,168,.55)"); rg.addColorStop(1, "rgba(232,180,168,0)");
  ctx.fillStyle = rg; ctx.fillRect(0, 0, W, H);
  const [logo, photo] = await Promise.all([load("/logo.png"), load(image)]);
  const lw = 520, lh = lw * (logo.height / logo.width);
  ctx.drawImage(logo, (W - lw) / 2, 70, lw, lh);
  const py = 80 + lh + 20, ph = 1260;
  ctx.shadowColor = "rgba(74,39,50,.35)"; ctx.shadowBlur = 60; ctx.shadowOffsetY = 30;
  ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.roundRect(90, py, W - 180, ph, 44); ctx.fill();
  ctx.shadowColor = "transparent";
  cover(ctx, photo, 90, py, W - 180, ph, 44);
  ctx.fillStyle = "#4A2732"; ctx.textAlign = "center";
  ctx.font = "italic 64px 'Cormorant Garamond', Georgia, serif";
  ctx.fillText(name, W / 2, py + ph + 100);
  ctx.font = "600 30px 'Familjen Grotesk', Arial, sans-serif"; ctx.fillStyle = "#A9615B";
  ctx.fillText(`${look ? `${look.toUpperCase()}  ·  ` : ""}${price}`, W / 2, py + ph + 155);
  ctx.font = "500 26px 'Familjen Grotesk', Arial, sans-serif"; ctx.fillStyle = "#8C7670";
  ctx.fillText("Tried on with REVASTRA AI  ·  @revastra._", W / 2, H - 60);
  return new Promise((res) => c.toBlob((b) => res(b), "image/jpeg", 0.92));
};
